import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./kit";

export default function SiteFooter() {
  return (
    <footer style={{ borderTop: "1px solid var(--border-hairline)", marginTop: "var(--space-24)" }}>
      <div
        className="buktu-wrap"
        style={{ paddingTop: "var(--space-10)", paddingBottom: "var(--space-10)", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "var(--space-6)" }}
      >
        <Logo height={24} />
        <span style={{ font: "var(--type-body-sm)", fontSize: 12, color: "var(--text-faint)" }}>
          © 2026 Buktu
        </span>
        <div style={{ marginLeft: "auto", display: "flex", gap: "var(--space-5)", flexWrap: "wrap", font: "var(--type-body-sm)", fontSize: 13, color: "var(--text-muted)" }}>
          <Link to="/solutions" style={{ borderBottom: 0, color: "var(--text-muted)" }}>Solutions</Link>
          <Link to="/pricing" style={{ borderBottom: 0, color: "var(--text-muted)" }}>Pricing</Link>
          <Link to="/login" style={{ borderBottom: 0, color: "var(--text-muted)" }}>Login</Link>
        </div>
      </div>
    </footer>
  );
}
